<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure><i class="icon icon-icon_calendar"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Closure event <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-text label="Title" v-model="resource.name" :required="true"></form-text>

                                <form-toggle label="Toute la journée" v-model="resource.all_day"></form-toggle>

                                <!--
                                <form-datex label="Start" v-model="resource.start_at" :hide-time="false" time="00:00:00" :required="true"></form-datex>
                                <form-datex label="End" v-model="resource.end_at" :hide-time="false" time="23:59:59" :required="true"></form-datex>
                                -->

                                <form-datetime label="Début" v-model="resource.start_at" :required="true" @update="refresh"></form-datetime>
                                <form-datetime label="Fin" v-model="resource.end_at" :required="true" @update="refresh"></form-datetime>

                                <form-checklist v-if="slots" label="Slots"
                                                v-model="resource.slots"
                                                :options="slots"
                                                multiple="true"
                                                name="title"
                                                color="eventBorderColor"
                                                :has-label="true"
                                                :show-has-all="true"
                                                v-bind:all.sync="resource.all_slots"
                                                :required="true"></form-checklist>

                              </fieldset>

                            </tab>
                        </tabs>

                    </main>
                </article>
            </div>
        </div>
    </transition>
</template>
<script>

    import Edit from '../../../layouts/Edit.vue';
    import ScopeService from '../../scope/ScopeService.js';
    import ScheduleService from '../../reservation/ScheduleService.js';

    export default {
        extends: Edit,
        data () {
            return {
                slots: null,
                resource: {
                    type: "closure"
                }
            }
        },
        mounted: function(){
            ScopeService.get(this.$store.state.scope.id).then((response) => {
                this.slots = [];
                if(response.data.slotables) {
                    for(let item of response.data.slotables){
                        this.slots.push({
                            id: item.id,
                            title: item.name,
                            editable: item.editable,
                            eventBackgroundColor: window.hexToRGBA(item.color, .6),
                            eventBorderColor: item.color
                        })
                    }
                    console.log('SLOTABLES',this.resource.slotables);
                    console.log('SLOTS',this.slots);
                }
            });
        },
        methods:{
            refresh: function(){
                this.$forceUpdate();
            },
            resourceLoaded: function(){
                this.localesLoaded = true;
                this.resource.type = "closure";
                this.resource.start_at = this.resource.start_at || moment().format();
                this.resource.end_at = this.resource.end_at || moment().format();

                /* CONVERT DATES TO LOCAL TIMZONE */
                this.resource.start_at = this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.start_at, this.$store.state.scope.timezone).format() : null;
                this.resource.end_at = this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone) ? this.$helpers.utcToLocal(this.resource.end_at, this.$store.state.scope.timezone).format() : null;
                /*****/

                this.initialize()
            },
            getResource: function(){
                return ScheduleService
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/config/closure/Edit.vue